/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Showcase_Own_Key_CostInputs */



/**
* | output |
* | --- |
* | "Own key · €0 in oneAI. Your provider bills you directly." |
*
* @param {Model_Showcase_Own_Key_CostInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_showcase_own_key_cost = /** @type {((inputs?: Model_Showcase_Own_Key_CostInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Showcase_Own_Key_CostInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eigener Schlüssel · 0 € in oneAI. Ihr Anbieter rechnet direkt mit Ihnen ab.")
	return /** @type {LocalizedString} */ ("Own key · €0 in oneAI. Your provider bills you directly.")
});